import { AdminProjectCategoryData } from '@models/interfaces';

export const PROJECT_CATEGORY_DEFAULT_VALUE: AdminProjectCategoryData = {
  id: '',
  value: '',
  isCanBeDuplicated: false,
};
